import deepFreeze from 'deep-freeze';
import { Styling } from './styling';
export var DefaultVelocityTheme = deepFreeze({
    styling: Styling,
});
//# sourceMappingURL=DefaultVelocityTheme.js.map